import { render, staticRenderFns } from "./Submitted.vue?vue&type=template&id=3ddb4fb0&scoped=true"
import script from "./Submitted.vue?vue&type=script&lang=js"
export * from "./Submitted.vue?vue&type=script&lang=js"
import style0 from "./Submitted.vue?vue&type=style&index=0&id=3ddb4fb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddb4fb0",
  null
  
)

export default component.exports